export default {
    title: "Bestelling namens",
    model: {
        email: {
            label: "E-mail",
            placeholder: "Vul uw gebruikersnaam of e-mailadres in",
            notFound: "Gebruikers niet gevonden",
            errors: {
                myself: "Uw e-mailadres moet afwijken van uw"
            }
        }
    },
    cta: {
        impersonate: {
            cta: "Indienen",
            processing: "Inzenden"
        }
    },
    error: {
        userNotExists: "{email} bestaat niet",
        country: {
            default: "OI is momenteel niet beschikbaar in het land van de gebruiker",
            ALPHA3: ""
        }
    }
}